import './main.less';
import React from 'react';
import cn from 'classname';
import _get from 'lodash/get';
import { Link } from 'react-router';

const Row = props => {
	const { addSpecificGrouping, row, groupsSelectControls, queryToConversionsSimple, isGroupedByReason } = props;

	const { first, second } = groupsSelectControls;
	const [ firstCol, secondCol ] = [first, second].map(i => _get(i, 'value.0.label'));
	const [ firstColVal, secondColVal ] = [first, second].map(i => _get(i, 'value.0.value'));
	if (!firstCol)
		return null;

	return (
		<tr>
			{
				!secondCol &&
				<td className="group modify__last-element-in-group">
					<span
						className={cn({'group__text': !!row[firstColVal], 'bald-font': !row[firstColVal]})}
					>
						{row[firstColVal] || 'Отсутствует'}
					</span>
				</td>
			}
			{
				!!secondCol &&
				<td className="group modify__last-element-in-group">
					<span className={cn({'group__text': !!row[secondColVal], 'bald-font': !row[secondColVal]})}>
						{row[secondColVal] || 'Отсутствует'}
					</span>
				</td>
			}
			{
				!isGroupedByReason &&
				<td>
					<Link
						to={`/statistics/conversions?${
							queryToConversionsSimple(
								row, ['approved', 'rejected', 'pending']
							)}`
						}
					>
						<span>{ row['valid_count']}</span>
					</Link>
				</td>
			}
			<td className="modify__border-left">
				<Link
					to={`/statistics/conversions?${
						queryToConversionsSimple(row, ['rejected'])}`
					}
				>
					<span>{ row['rejected_count']}</span>
				</Link>
			</td>
			<td className="modify__border-left">
				<Link
					to={`/statistics/conversions?${
						queryToConversionsSimple(row, ['trash'])}`
					}
				>
					<span>{ row['trash_count']}</span>
				</Link>
			</td>
			<td className="modify__border-left">
				<Link
					to={`/statistics/conversions?${
						queryToConversionsSimple(row, ['trash', 'rejected'])}`
					}
				>
					<span>{ row['rejected_and_trash_count']}</span>
				</Link>
			</td>
			{
				!isGroupedByReason &&
				<td>
					<Link
						to={`/statistics/conversions?${
							queryToConversionsSimple(
								row, ['approved', 'rejected', 'pending', 'trash']
							)}`
						}
					>
						<span>{ row['total_count']}</span>
					</Link>
				</td>
			}
			<td onClick={addSpecificGrouping} className="hover-pointer"><span>{row.rejected_to_valid}</span></td>
			<td  onClick={addSpecificGrouping} className="hover-pointer"><span>{row.trash_to_valid}</span></td>
			<td  onClick={addSpecificGrouping} className="hover-pointer"><span>{row.trash_to_total}</span></td>
		</tr>
	);
};

export default Row;



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/statistics/components/table/invalid/row.js